import { Model } from '@/models/Model';
import { Country } from '@/models/Country';

export class Address extends Model
{
  protected $name: string = 'Address';
  protected $endpoint: string = '/addresses';
  protected $fillable: string[] = [
    'country',
    'street',
    'number',
    'number_add',
    'postcode',
    'city',
    'contact',
  ];

  public country?: Country | string;
  public street?: string;
  public number?: string;
  public number_add?: string;
  public postcode?: string;
  public city?: string;
  public contact?: string;
  public id?: string;
}
